import style from './P2PContactCardListPageView.css';
import Title from '../../shared/Typography/Title';
import useTranslation from '../../../localization/i18n.context';
import List from '../../shared/List/List';
import ListItem from '../../shared/List/ListItem';
import CardThumbnail from '../../shared/CardThumbnail/CardThumbnail';
import NavigationUtils from '../../../utils/navigation.utils';
import Alert from '../../shared/Alert/Alert';
import { renderIf } from '../../../utils/render.utils';
import { EnterAmountType } from '../../../routes/EnterAmountPage/EnterAmountProvider';

export default function P2PContactCardListPageView({
  className = '',
  cards = [],
  cardUid,
}) {
  const { t, getOrganization } = useTranslation();

  return (
    <main className={`${style.container} ${className}`}>
      <Title
        text={t(
          cards.length > 0
            ? 'Which card would you like to send money to?'
            : "Your contact doesn't have an active card of the current organization",
        )}
        className={style.title}
      />
      {renderIf(
        cards.length === 0,
        <Alert
          hasIcon
          type={Alert.Type.WARNING}
          message={t(
            'Your contact must have an active card to receive your money',
          )}
          className={style['info-box']}
        />,
      )}
      {renderIf(
        cards.length > 0,
        <List className={style.list}>
          {cards.map(card => (
            <ListItem
              actionable={true}
              icon={
                <CardThumbnail
                  organization={card.organizationCode}
                  size={CardThumbnail.Size.SMALL}
                />
              }
              title={getOrganization(card.organizationCode)}
              subtitle={card.name}
              className={style.item}
              onClick={() =>
                NavigationUtils.navigate(
                  NavigationUtils.Routes.ENTER_AMOUNT,
                  false,
                  { cardUidTo: card.uid, cardUidFrom: cardUid, type: EnterAmountType.P2P },
                )
              }
            />
          ))}
        </List>,
      )}
    </main>
  );
}
